import { Radio } from 'antd';
import styled from 'styled-components';

export const NextInspectionDueOptions = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
